import React from 'react'
import styles from './ErrorMessage.module.scss'

export const ErrorMessage = (props: {
  children: React.ReactNode
}): JSX.Element => {
  const { children: childComponents } = props
  return <div className={styles.MessageContainer}>{childComponents}</div>
}
